import { Route, Routes } from "react-router-dom";
import { PrivateRoutes } from '../utils/PrivateRoutes';
import HomePage from "../pages/HomePage";
import DomainPage from "../pages/DomainPage";
import HostingPage from "../pages/HostingPage";
import VPSPage from "../pages/VPSPage";
import HelpingCenterPage from '../pages/HelpingCenterPage';
import HelpingCenterDeteilPage from '../pages/HelpingCenterDetailsPage';
import LoginPage from "../pages/user/LoginPage";
import RegisterPage from '../pages/user/RegisterPage';
import RegisterEmailSubmit from "../pages/user/RegisterEmailSubmit";
import CartPage from "../pages/CartPage";
import UserDashboard from "../pages/user/UserDashboard";
import UserDomainPage from "../pages/user/domains";
import UserHostingPage from '../pages/user/hostings';
import UserSingleHostingPage from '../pages/user/hosting-details';
import UserDomainDetailPage from '../pages/user/domain-details';
import DomainRegisterDetails from '../pages/user/DomainRegisterDetails';
import EditDomainDnsServer from '../pages/user/edit-domain-dns-server';
import EditDomainContactInfo from "../pages/user/edit-domain-contact-info";
import RegisterHosting from "../pages/RegisterHosting";
import PaymentPage from "../pages/user/payment-page";
import SSLPage from "../pages/SSLPage";
import SSLCategoryPage from "../pages/user/ssl/SSLCategoryPage";
import SSlGenerateCSR from "../pages/user/ssl/SSlGenerateCSR";
import SSLApprovedEmail from "../pages/user/ssl/SSLApprovedEmail";
import SSLAgreementPage from "../pages/user/ssl/SSLAgreementPage";
import SSLOrder from "../pages/user/ssl/SSLOrder";
import SSLOrderStatus from "../pages/user/ssl/SSLOrderStatus";
import SoldSSLList from "../pages/user/ssl/SoldSSLList";
import SoldSSLSingle from "../pages/user/ssl/SoldSSLSingle";
import TermsandConditions from '../pages/privacyiPolicy/TermsandConditions'
import ServiceDelivery from '../pages/privacyiPolicy/ServiceDelivery'
import AccetableUse from '../pages/privacyiPolicy/AccetableUse'
import PrivacyPolicy from '../pages/privacyiPolicy/PrivacyPolicy'
import RefundPolicy from '../pages/privacyiPolicy/RefoundPolicy'
import NotFoundPage from "../pages/NotFoundPage";

export default function useRouter() {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/helping-center" element={<HelpingCenterPage />} />
            <Route path="/helping-center/:id" element={<HelpingCenterDeteilPage />} />
            <Route path="/domain" element={<DomainPage />} />
            <Route path="/hosting" element={<HostingPage />} />
            <Route path="/hosting/:plan_name" element={<RegisterHosting />} />
            <Route path="/ssl" element={<SSLPage />} />
            <Route path="/vps" element={<VPSPage />} />
            <Route path="/user/login" element={<LoginPage />} />
            <Route path="/user/register" element={<RegisterPage />} />
            <Route path="/user/register/email-submit" element={<RegisterEmailSubmit />} />
            <Route path="/terms-and-conditions" element={<TermsandConditions />} />
            <Route path="/service-delivery" element={<ServiceDelivery />} />
            <Route path="/acceptable-use" element={<AccetableUse />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />

            <Route path="/user" element={<PrivateRoutes />}>
                <Route index element={<UserDashboard />} />
                <Route path="domains" element={<UserDomainPage />} />
                <Route path="domains/:id" element={<UserDomainDetailPage />} />
                <Route path="domains/:id/edit-dns" element={<EditDomainDnsServer />} />
                <Route path="domains/:id/edit-domain-contact-info" element={<EditDomainContactInfo />} />
                <Route path="hostings" element={<UserHostingPage />} />
                <Route path="hostings/:id" element={<UserSingleHostingPage />} />
                <Route path="cart" element={<CartPage />} />
                <Route path="domain-register-details" element={<DomainRegisterDetails />} />
                <Route path="payment-method" element={<PaymentPage />} />
                <Route path="ssl" element={<SoldSSLList />} />
                <Route path="ssl/:id" element={<SoldSSLSingle />} />
                <Route path="ssl/category/:brand" element={<SSLCategoryPage />} />
                <Route path="ssl/csr-generator" element={<SSlGenerateCSR />} />
                <Route path="ssl/approved-email" element={<SSLApprovedEmail />} />
                <Route path="ssl/agreement" element={<SSLAgreementPage />} />
                <Route path="ssl/order" element={<SSLOrder />} />
                <Route path="ssl/order-status" element={<SSLOrderStatus />} />
            </Route>

            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    )
}
